import NavigationActionCreator from 'action_creators/navigation';

export default {
  _renderMoreDetails() {
    return null;
    /*
    BRING THIS BACK AFTER FIXING THE PAGE IT LEADS TO...
    return (
      <a className="Mobile-Only" href="#" onClick={this._transitionToSummary}>More Details</a>
    );
    */
  },

  _transitionToSummary(e) {
    e.preventDefault();
    NavigationActionCreator.transitionTo(
      'Views.Plugins.Confirmation.Mobile.Screens.Summary'
    );
  },
};
